export const urlFormat = (url: string) => {
    return url.toLowerCase().replace(/ /g, '');
};
